"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConnectSocket = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _helpers = require("../../../../utils/helpers");
var _useStartSocket = require("./useStartSocket");
var _WebSocketAction = require("./WebSocketAction");
var _socketConfig = require("./socket-config");
var _sockets = require("../../../../entities/sockets");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const defaultReconnectCount = 0;
const second = 1000;
const timeoutReconnect = 3 * second;
const heartbeatInterval = 30 * second;
const useConnectSocket = _ref => {
  let {
    socketId,
    mustBeOpen,
    logPrefix,
    hideLogs = false,
    socketUrl
  } = _ref;
  const heartbeat = (0, _react.useRef)(null);
  const reconnectTimeoutRef = (0, _react.useRef)(null);
  const [reconnectCount, setReconnectCount] = (0, _react.useState)(defaultReconnectCount);
  const socket = (0, _reactRedux.useSelector)((0, _sockets.selectSocketById)({
    socketId
  }));
  (0, _useStartSocket.useStartSocket)({
    socketUrl,
    mustBeOpen,
    socketId,
    logPrefix,
    hideLogs,
    reconnectCount
  });
  (0, _react.useEffect)(() => {
    if (socket) {
      const makeHeartbeat = () => {
        if (!socket || socket.readyState === _socketConfig.readyStates.CLOSED) return;
        (0, _WebSocketAction.socketSend)({
          method: 'ping',
          socket
        });
      };
      socket.onopen = () => {
        (0, _helpers.getLog)({
          logPrefix,
          hideLogs,
          text: "Connected to ".concat(socketUrl)
        });
        heartbeat.current = setInterval(makeHeartbeat, heartbeatInterval);
      };
      socket.onclose = () => {
        const logReconnectText = mustBeOpen ? "Reconnect after ".concat(timeoutReconnect / second, " seconds") : '';
        (0, _helpers.getLog)({
          logPrefix,
          hideLogs,
          text: "Socket disconnected. ".concat(logReconnectText)
        });
        clearTimeout(reconnectTimeoutRef.current);
        clearTimeout(heartbeat.current);
        if (!mustBeOpen) return;
        reconnectTimeoutRef.current = setTimeout(() => {
          setReconnectCount(prev => prev + 1);
        }, timeoutReconnect);
      };
      socket.onerror = () => {
        (0, _helpers.getLog)({
          logPrefix,
          hideLogs,
          text: 'Socket error occurred'
        });
        socket.close();
      };
    }
  }, [hideLogs, logPrefix, mustBeOpen, socket, socketUrl]);

  /** @todo disconnect socket on destroy */
  /** @todo clear timeout after disconnect */
};
exports.useConnectSocket = useConnectSocket;
useConnectSocket.propTypes = {
  socketUrl: _propTypes.default.string,
  socketId: _propTypes.default.string.isRequired,
  mustBeOpen: _propTypes.default.bool.isRequired,
  logPrefix: _propTypes.default.string,
  hideLogs: _propTypes.default.bool
};